// Create a global tracker object for handling tracking

window.Tracker = {
  track(obj) {
    window.dataLayer = window.dataLayer || []
    dataLayer.push(obj)
  }
}
